import type { FC, ReactNode } from 'react'
import type { ServiceSummary } from '@/types'

import Link from 'next/link'

import { Button } from '@/components/generals/button'

type ServicesGridProps = {
    services: ServiceSummary[]
    heading?: string
    subheading?: string
    ctaLabel?: string
    ctaHref?: string
    sectionClassName?: string
}

export const ServicesGrid: FC<ServicesGridProps> = ({
    services,
    heading,
    subheading,
    ctaLabel,
    ctaHref,
    sectionClassName = 'service-section section-padding'
}): ReactNode => {
    const list = (
        <div className='w-dyn-list'>
            <div role='list' className='service-list w-dyn-items' data-reveal-stagger='0.08'>
                {services.map((service) => (
                    <div key={service.id} role='listitem' className='w-dyn-item'>
                        <Link
                            href={`/services/${service.slug}`}
                            className='single-service w-inline-block'
                        >
                            <div className='service-thumbnail-wrapper'>
                                <img
                                    src={service.cardImage}
                                    loading='lazy'
                                    alt={service.cardImageAlt}
                                    className='service-thumbnail'
                                />
                            </div>

                            <div className='service-title-wrapper'>
                                <p
                                    className='service-title'
                                    data-mdlfy-cms={`services:${service.id}:card_title`}
                                >
                                    {service.cardTitle}
                                </p>

                                <div className='service-icon-box'>
                                    <img
                                        src='/images/arrow-up-right-3-1.svg'
                                        loading='lazy'
                                        alt=''
                                        className='service-arrow-icon'
                                    />

                                    <img
                                        src='/images/arrow-up-right-3-1-1.svg'
                                        loading='lazy'
                                        alt=''
                                        className='service-arrow-icon hover'
                                    />
                                </div>

                                <div className='service-border'>
                                    <div className='service-active-border' />
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    )

    return (
        <section className={sectionClassName}>
            <div className='w-layout-blockcontainer hero-container w-container'>
                {heading ? (
                    <div className='section-content-wrapper'>
                        <div className='section-title-wrapper align-center' data-reveal>
                            <h2 className='section-title'>
                                {heading}
                            </h2>

                            {subheading && (
                                <p className='section-subtitle'>
                                    {subheading}
                                </p>
                            )}
                        </div>

                        {list}

                        {ctaLabel && ctaHref && (
                            <div className='service-button-wrapper' data-reveal>
                                <Button href={ctaHref} label={ctaLabel} variant='style-04' />
                            </div>
                        )}
                    </div>
                ) : (
                    list
                )}
            </div>
        </section>
    )
}
